module.exports = __webpack_public_path__ + "img/cote-pc-0218-04.a0433bdc.png";